import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router';

import { AppRoutesWrapper } from '@/App/AppRoutesWrapper';
import { theme } from '@/App/theme';
import { AppSpinner } from '@/components/common/AppSpinner';
import { withConfig } from '@/features/config/withConfig';
import CsrfService from '@/services/CsrfService';
import ExpEngine from '@/services/ExpEngine';

export const AppComponent: React.FC = () => {
  const [isAppReady, setIsAppReady] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      ExpEngine.initialize();
      await CsrfService.initialize();
      if (ExpEngine.isInitialized() && CsrfService.isInitialized()) {
        setIsAppReady(true);
      }
    };

    initializeApp().catch((error) => console.error('Failed to initialize application:', error));
  }, []);

  if (!isAppReady) {
    return <AppSpinner />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRoutesWrapper />
      </BrowserRouter>
      <AppSpinner />
    </ThemeProvider>
  );
};

export const App = withConfig(AppComponent);
